export const formatDate = (
  date: string | Date,
  options?: Intl.DateTimeFormatOptions
) => {
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options
  });
};
